export default {
  state: {
    isLoadingFullPage: false,
    loadingFullPageMessages: [],
    intervalBetweenMessages: 2500
  },

  mutations: {
    LOADING_FULL_PAGE (state, { messages, interval }) {
      state.isLoadingFullPage = true
      state.loadingFullPageMessages = messages
      state.intervalBetweenMessages = interval
    },

    FULL_PAGE_LOADED (state) {
      state.isLoadingFullPage = false
      state.loadingFullPageMessages = []
      state.intervalBetweenMessages = 2500
    }
  },

  actions: {
    loadingFullPage: ({ commit }, { messages, interval = 2500 }) => {
      commit('LOADING_FULL_PAGE', { messages, interval })
    },

    fullPageLoaded: ({ commit }) => {
      commit('FULL_PAGE_LOADED')
    }
  },

  getters: {
    isLoadingFullPage: state => state.isLoadingFullPage,
    loadingFullPageMessages: state => state.loadingFullPageMessages,
    intervalBetweenMessages: state => state.intervalBetweenMessages
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/loadingFullPage.js